import React from 'react'
import ResponsiveModal from 'react-responsive-modal'

// Por encima del sidesheet MUI y del z-index por defecto de react-responsive-modal (1000)
const Z_OVER_SIDE_SHEET_OVERLAY = 1400
const Z_OVER_SIDE_SHEET_MODAL = 1401

/**
 * Objeto con las clases para estilizar el modal.
 * @typedef {Object} ClassNamesObject
 * @property {String} overlay - Clase para el div overlay.
 * @property {String} modal - Clase para el div contenedor del modal.
 * @property {String} closeButton - Clase para el boton de cerrar.
 * @property {String} closeIcon - Clase para el icono svg de cerrar.
 * @property {String} transitionEnter - Clase de transicion al ingresar.
 * @property {String} transitionEnterActive - Clase de transicion al ingresar en estado activo.
 * @property {String} transitionExit - Clase de transicion al salir.
 * @property {String} transitionExitActive - Clase de transicion al salir en estado activo.
 */

/**
 * @description Renderiza un modal
 * @param {Object} props Objeto de props
 * @param {Function} props.onClose Callback para cerrar el modal
 * @param {JSX.Element} props.children Elementos a mostrar en el modal
 * @param {ClassNamesObject} props.classNames Objeto con clases de estilos
 * @returns {JSX.Element}
 */
function Modal({ onClose, children, classNames, modalId, style }) {
    const styles = {
        overlay: { zIndex: Z_OVER_SIDE_SHEET_OVERLAY },
        modal: { zIndex: Z_OVER_SIDE_SHEET_MODAL, ...(style || {}) },
    }
    return (
        <ResponsiveModal
            open={true}
            onClose={onClose}
            onOverlayClick={onClose}
            showCloseIcon={false}
            focusTrapped={false}
            center
            classNames={classNames}
            modalId={modalId}
            styles={styles}
        >
            {children}
        </ResponsiveModal>
    )
}

Modal.defaultProps = {
    onClose: () => {},
    children: <></>,
    classNames: {}
}

export default Modal
